import React from "react";

import { ExportWizardModal, useExportWizardModalContext } from "../export_wizard";
import { ExportButton } from "./export_button";

export const Export = (): JSX.Element => {
  const {
    open,
    state: { isOpen }
  } = useExportWizardModalContext();
  return (
    <>
      <ExportButton onClick={() => open()} />
      {isOpen && <ExportWizardModal />}
    </>
  );
};
